import ContainedIcon from '@/components/ContainedIcon';
import DeepSeekIconBase from '@/components/Icons/DeepSeekIcon';
import { SharedEndpointModelFamily } from '@/graphql';

import {
  mapIconSizeToSize,
  mapModelFamilyToIconColor,
  mapModelFamilyToIconContainerColor,
} from '../utils';
import { SharedEndpointIconProps, SharedEndpointIconSize } from './types';

function DeepSeekIcon({ size }: SharedEndpointIconProps) {
  const [containerSize, iconSize] = mapIconSizeToSize(size);

  return (
    <ContainedIcon
      size={containerSize}
      color={mapModelFamilyToIconContainerColor(SharedEndpointModelFamily.Deepseek)}
      borderRadius={size === SharedEndpointIconSize.XSMALL ? 6 : 8}
    >
      <DeepSeekIconBase
        sx={{
          width: iconSize,
          height: iconSize,
          color: mapModelFamilyToIconColor(SharedEndpointModelFamily.Deepseek),
        }}
      />
    </ContainedIcon>
  );
}

export default DeepSeekIcon;
